/**
 * The text of a PDF with positions, read on the device with pdf.js (docs/18-vorratsbuch.md,
 * Eingänge). Loaded only when someone reads a document; the worker is precached, so it works
 * without signal too.
 */
import type { PdfItem } from "@lagerlog/core";

export async function pdfItems(data: ArrayBuffer): Promise<PdfItem[]> {
  const [pdfjs, worker] = await Promise.all([import("pdfjs-dist"), import("pdfjs-dist/build/pdf.worker.min.mjs?url")]);
  pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
  const task = pdfjs.getDocument({ data: new Uint8Array(data), verbosity: 0 });
  const doc = await task.promise;
  const items: PdfItem[] = [];
  try {
    for (let page = 1; page <= doc.numPages; page++) {
      const content = await (await doc.getPage(page)).getTextContent();
      for (const it of content.items) {
        if (!("str" in it) || it.str.trim() === "") continue;
        items.push({ page, x: it.transform[4] as number, y: it.transform[5] as number, w: it.width, str: it.str });
      }
    }
  } finally {
    await task.destroy();
  }
  return items;
}
